import { CssBaseline, ThemeProvider, useMediaQuery } from '@mui/material'
import Topbar from './Topbar/Topbar'
import Sidebar from './Navbar/Sidebar'
import { Outlet } from 'react-router-dom'
import { ColorModeContext, useMode } from './theme'
import Navbar from './MobileNavBar/Navbar'

const Layout = () => {

  const [theme, colorMode] = useMode()
  const isMobile = useMediaQuery('(max-width:600px)')
  
    return (
    <>
  <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>

            <CssBaseline />
            <div className="app">
              {isMobile ? (
                <Navbar />
                ) : (
                  <Sidebar />
                )}
              <main className="content">
                <Topbar />
                  <Outlet />
              </main>
            </div>
      
        </ThemeProvider>
  </ColorModeContext.Provider>
      
    </>
    )
  }

  export default Layout
